<ngb-toast *ngFor="let toast of toasts"
[class]="toast.classname"
[animation]="true"
[autohide]="true"
[delay]="toast.delay || 5000"
(hidden)="hiddenToast(toast)"
>
<ng-template [ngTemplateOutlet]="toast.template"></ng-template>
</ngb-toast>
